import logoDark from '../../assets/brand/logo-dark.svg';
import logoLight from '../../assets/brand/logo-light.svg';
import useThemeStore, { selectTheme } from '../../stores/themeStore.js';

/**
 * The Chapters&Co stamp mark, exactly as supplied — never recoloured, rotated,
 * cropped or redrawn. The two files exist because the mark has a baked fill and
 * cannot take `currentColor`: `dark` is the black mark for paper, `light` the
 * white mark for ink.
 *
 * `variant="auto"` (the default) follows the theme, which is what anything
 * sitting on the page background wants. Surfaces that are dark in BOTH themes —
 * the footer slab, an ink button — pass `variant="light"` explicitly and keep
 * the white mark whatever the reader has chosen.
 */
export default function Logo({ variant = 'auto', size = 34, className = '', title }) {
  const theme = useThemeStore(selectTheme);
  const resolved = variant === 'auto' ? (theme === 'dark' ? 'light' : 'dark') : variant;

  return (
    <img
      src={resolved === 'light' ? logoLight : logoDark}
      width={size}
      height={Math.round((size * 4424) / 4656)}
      alt={title ?? ''}
      aria-hidden={title ? undefined : 'true'}
      className={className}
      draggable="false"
    />
  );
}
